import { httpRequest } from "../../http";
import type { DiscrepancyFile } from "@models/Discrepancy.model";

/** The discrepancy's population's loaded files, newest first: where a correction can start. */
export class CommandListDiscrepancyFiles {
  async run(discrepancyId: number): Promise<DiscrepancyFile[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/discrepancies/${discrepancyId}/files/`;
    return httpRequest<DiscrepancyFile[]>(url, { method: "GET" });
  }
}
